
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class HsnMasterDialog extends Serenity.EntityDialog<HsnMasterRow, any> {
        protected getFormKey() { return HsnMasterForm.formKey; }
        protected getIdProperty() { return HsnMasterRow.idProperty; }
        protected getLocalTextPrefix() { return HsnMasterRow.localTextPrefix; }
        protected getNameProperty() { return HsnMasterRow.nameProperty; }
        protected getService() { return HsnMasterService.baseUrl; }
        protected getDeletePermission() { return HsnMasterRow.deletePermission; }
        protected getInsertPermission() { return HsnMasterRow.insertPermission; }
        protected getUpdatePermission() { return HsnMasterRow.updatePermission; }

        protected form = new HsnMasterForm(this.idPrefix);

    }
}